import { useState, useEffect } from 'react';
import TablaUsuarios from '../Users/TablaUsuarios';
import Test from '../Test/Test';
import Pasos from '../Pasos/Pasos';
import Universidades from '../Universidades/Universidades';
import Becas from '../Becas/Becas'; 
import styles from './ControlPanel.module.css';
import { useAuth } from '../../Auth/AuthContext';
import { FaUsers, FaBrain, FaGraduationCap, FaArrowLeft, FaArrowRight, FaClipboardList, FaMoneyCheck} from 'react-icons/fa';

const ControlPanel = () => {
  const {getToken, userData } = useAuth();
  const token = getToken(); 
  const [admin, setAdmin] = useState(null);
  const [activeTab, setActiveTab] = useState('usuarios');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  useEffect(() => {
    if (token) {
      fetch(`${process.env.REACT_APP_API_URL}/perfil/usuario/${userData.id}`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
        .then(res => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
        .then(data => {
          setAdmin(data);
        })
        .catch(err => {
          console.error('Error al obtener datos del admin:', err);
        });
    }
  }, []);

  const getUserImage = () => {
    if (userData && userData.profile_image) {
      return userData.profile_image;
    }
    return null;
  };

  const getInitial = () => {
    if (userData && userData.nombre) {
      return userData.nombre.charAt(0).toUpperCase();
    }
    if (admin && admin.nombre) {
      return admin.nombre.charAt(0).toUpperCase();
    }
    return 'A';
  };

  const getUserName = () => {
    if (userData && userData.nombre) {
      return `${userData.nombre} ${userData.apellido_paterno || ''} ${userData.apellido_materno || ''}`.trim();
    }
    if (admin && admin.nombre) {
      return `${admin.nombre} ${admin.apellido_paterno} ${admin.apellido_materno}`;
    }
    return 'Usuario';
  };

return (
  <div className={styles.controlPanel}>
    <div className={`${styles.sidebar} ${sidebarCollapsed ? styles.sidebarCollapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        {!sidebarCollapsed && <h2>Panel de Administración</h2>}
        <div className={styles.userInfo}>
          {getUserImage() ? (
            <img
              className={sidebarCollapsed ? styles.miniIconoAdmin : styles.iconoAdmin}
              src={getUserImage()}
              alt="Imagen de usuario"
            />
          ) : (
            <div
              className={sidebarCollapsed ? styles.miniIconoAdmin : styles.iconoAdmin}
              aria-label={`Inicial del usuario: ${getInitial()}`}
            >
              {getInitial()}
            </div>
          )}
          {!sidebarCollapsed && (
            <h4>{getUserName()}</h4>
          )}
        </div>
      </div>
      <ul className={styles.navLinks}>
        <li
          className={activeTab === 'usuarios' ? styles.active : ''}
          onClick={() => setActiveTab('usuarios')}
          title="Gestión de Usuarios"
        >
          <FaUsers className={`${styles.iconWhite} ${styles.mobileIcon}`} />
          <span className={styles.mobileText}>
            {sidebarCollapsed ? <FaUsers className={styles.iconWhite} /> : 'Gestión de usuarios'}
          </span>
        </li>
        <li
          className={activeTab === 'estadisticas' ? styles.active : ''}
          onClick={() => setActiveTab('estadisticas')}
          title="Estadísticas"
        >
          <FaGraduationCap className={`${styles.iconWhite} ${styles.mobileIcon}`} />
          <span className={styles.mobileText}>
            {sidebarCollapsed ? <FaGraduationCap className={styles.iconWhite} /> : 'Universidades y carreras'}
          </span>
        </li>
        <li
          className={activeTab === 'becas' ? styles.active : ''}
          onClick={() => setActiveTab('becas')}
          title="Becas"
        >
          <FaMoneyCheck className={`${styles.iconWhite} ${styles.mobileIcon}`} />
          <span className={styles.mobileText}>
            {sidebarCollapsed ? <FaMoneyCheck className={styles.iconWhite} /> : 'Becas'}
          </span>
        </li>
        <li
          className={activeTab === 'test' ? styles.active : ''}
          onClick={() => setActiveTab('test')}
          title="Test"
        >
          <FaBrain className={`${styles.iconWhite} ${styles.mobileIcon}`} />
          <span className={styles.mobileText}>
            {sidebarCollapsed ? <FaBrain className={styles.iconWhite} /> : 'Test'}
          </span>
        </li>
        <li
          className={activeTab === 'pasos' ? styles.active : ''}
          onClick={() => setActiveTab('pasos')}
          title="Pasos"
        >
          <FaClipboardList className={`${styles.iconWhite} ${styles.mobileIcon}`} />
          <span className={styles.mobileText}>
            {sidebarCollapsed ? <FaClipboardList className={styles.iconWhite} /> : 'Pasos'}
          </span>
        </li>
      </ul>
    </div>

    <button
      className={`${styles.toggleBtn} ${sidebarCollapsed ? styles.toggleBtnCollapsed : ''}`}
      onClick={toggleSidebar}
      aria-label={sidebarCollapsed ? "Expandir menú" : "Colapsar menú"}
    >
      {sidebarCollapsed ? <FaArrowRight /> : <FaArrowLeft />}
    </button>

    <div className={`${styles.content} ${sidebarCollapsed ? styles.contentExpanded : ''}`}>
      {activeTab === 'usuarios' && <TablaUsuarios />}
      {activeTab === 'estadisticas' && <Universidades />}
      {activeTab === 'test' && <Test />}
      {activeTab === 'pasos' && <Pasos />}
      {activeTab === 'becas' && <Becas />}
    </div>
  </div>
);
};

export default ControlPanel;